import { DefaultOptions, UseMutationOptions } from '@tanstack/react-query';

//* Define your query config here
export const queryConfig = {
  queries: {
    // throwOnError: true,
    refetchOnWindowFocus: true,
    retry: false,
    staleTime: 1000 * 60,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: 1000 * 60,
  },
} satisfies DefaultOptions;

// Custom error type
export type NormalizedError = Error & {
  title?: string;
  message?: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> =
  Awaited<ReturnType<FnType>>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type QueryConfig<T extends (...args: any[]) => any> = Omit<
  ReturnType<T>,
  'queryKey' | 'queryFn'
>;

export type MutationConfig<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  MutationFnType extends (...args: any) => Promise<any>
> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  NormalizedError,
  Parameters<MutationFnType>[0]
>;
